import { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";
import "../styles/MaintenanceBlocker.css";
import { useLocation } from "react-router-dom";

/* react-icons */
import { FiTool, FiClock, FiAlertTriangle } from "react-icons/fi";

export default function MaintenanceBlocker() {

    const location = useLocation();

    // routes which should NOT be blocked
    const allowedRoutes = [
        "/devopstriologin",
        "/devopstrio/dashboard"
    ];

    const isAllowedRoute = allowedRoutes.some((path) =>
        location.pathname.startsWith(path)
    );

    const [activeMaintenance, setActiveMaintenance] = useState(null);

    const formatIST = (utcString) => {
        if (!utcString) return "";

        return new Date(utcString).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        });
    };

    // ✅ show / hide only by status
    const loadMaintenance = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/api/maintenance`);
            const data = res.data?.data || [];

            const activeItem = data.find(
                (m) => m.status === "Active"
            );

            setActiveMaintenance(activeItem || null);

        } catch (err) {
            console.error("Maintenance blocker load failed", err);
        }
    };

    useEffect(() => {
        loadMaintenance();
        const t = setInterval(loadMaintenance, 30000);
        return () => clearInterval(t);
    }, []);

    // disable scroll only when blocker is shown
    useEffect(() => {
        if (activeMaintenance && !isAllowedRoute) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [activeMaintenance, isAllowedRoute]);

    // do not block allowed routes
    if (!activeMaintenance || isAllowedRoute) return null;

    return (
        <div className="maintenance-blocker-overlay">
            <div className="maintenance-blocker-card">

                {/* Header icon */}
                <div className="mb-icon-wrap">
                    <FiTool className="mb-main-icon" />
                </div>

                <h2 className="mb-title">
                    System Maintenance in Progress
                </h2>

                <div className="mb-message">
                    <FiAlertTriangle className="mb-inline-icon" />
                    <span>Due to ongoing maintenance, Please try again later.</span>
                </div>

                <div className="mb-time">

                    <div className="mb-time-row">
                        <FiClock className="mb-inline-icon" />
                        <span>
                            <strong>Start :</strong>{" "}
                            {formatIST(activeMaintenance.startTime)}
                        </span>
                    </div>

                    <div className="mb-time-row">
                        <FiClock className="mb-inline-icon" />
                        <span>
                            <strong>End :</strong>{" "}
                            {formatIST(activeMaintenance.endTime)}
                        </span>
                    </div>

                </div>

                <p className="mb-note">
                    Access to the system is temporarily disabled.
                    Please wait until the maintenance is completed.
                </p>

                <p className="mb-thankyou">
                    Thank you for your patience.
                </p>

            </div>
        </div>
    );
}
